import { Field } from "formik";
import { React } from "react";
import { ReactComponent as VisaCardIcon } from "../../icons/visaCardIcon.svg";
import { ReactComponent as MasterCardIcon } from "../../icons/masterCardIcon.svg";
import { ReactComponent as AmericanCardIcon } from "../../icons/americanCardIcon.svg";
import { ReactComponent as DiscoverCardIcon } from "../../icons/discoverCardIcon.svg";
//import { ReactComponent as PayPalIconLg } from "../../icons/paypalIconLg.svg";
import { ReactComponent as EloPay } from "../../icons/eloPay.svg";
import { ReactComponent as JCBPay } from "../../icons/jcbPay.svg";
import { ReactComponent as UniionPay } from "../../icons/uniounPay.svg";
//import { ReactComponent as RedirectionView } from "../../icons/redirectionView.svg";
//import shopPayIconLg from "../../icons/shopPayIconLg.svg";
//import klarnaIcon from "../../icons/klarnaIcon.svg";
import { CreditCardBox } from "./CreditCardBox";
import Tooltip from "../shared/Tooltip";
//import { classes } from "../../utils/Classes";

export const PaymentMethod = (props) => {
  const { values } = props;
  // const stripe = useStripe();
  // const elements = useElements();
  // //const { maxHeightTrans } = classes;
  // const [errorMessage, setErrorMessage] = useState(null);

  // const handleSubmit = async (event) => {
  //   // We don't want to let default form submission happen here,
  //   // which would refresh the page.
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     // Stripe.js hasn't yet loaded.
  //     // Make sure to disable form submission until Stripe.js has loaded.
  //     return;
  //   }

  //   const { error } = await stripe.confirmPayment({
  //     //`Elements` instance that was used to create the Payment Element
  //     elements,
  //     confirmParams: {
  //       return_url: "https://example.com/order/123/complete",
  //     },
  //   });

  //   if (error) {
  //     // This point will only be reached if there is an immediate error when
  //     // confirming the payment. Show error to your customer (for example, payment
  //     // details incomplete)
  //     setErrorMessage(error.message);
  //   } else {
  //     // Your customer will be redirected to your `return_url`. For some payment
  //     // methods like iDEAL, your customer will be redirected to an intermediate
  //     // site first to authorize the payment, then redirected to the `return_url`.
  //   }
  // };
  return (
    <div>
      <div className="block text-xl font-medium text-black mb-3">
        <span>Payment</span>
        <p className="text-sm text-mediumGray font-normal">
          All transactions are secure and encrypted.
        </p>
      </div>

      <div role="group" className="flex flex-col">
        <label
          className={`gap-2 text-sm text-black w-full h-14 border rounded-t-md flex items-center px-3 sm:px-6 cursor-pointer ${
            values.payment === "creditCard"
              ? "bg-lightStealBlue border-black"
              : "border-pearlGray border-b-0"
          }`}
        >
          <div class="relative">
            <Field
              className="_6hzjvo4"
              type="radio"
              name="payment"
              value="creditCard"
            />
          </div>

          <div className="flex justify-between items-center w-full">
            <span>Credit card</span>
            <div className="flex flex-wrap gap-2 z-10">
              <VisaCardIcon />
              <MasterCardIcon />
              <AmericanCardIcon />
              <DiscoverCardIcon className="hidden sm:block" />
              <Tooltip
                content={
                  <div className="flex py-2 gap-1">
                    <EloPay />
                    <JCBPay />
                    <UniionPay />
                  </div>
                }
              >
                <div
                  style={{ borderRadius: "3px", width: "38px" }}
                  className="h-6 bg-white border border-transparentBlack text-center"
                >
                  +3
                </div>
              </Tooltip>
            </div>
          </div>
        </label>

        <div
          className={`rounded-b-md  bg-whiteSmoke w-full border-pearlGray ${
            values.payment === "creditCard" ? `border` : "border-0"
          }`}
        >
          <CreditCardBox {...{ values }} />
          {/* {errorMessage && <div>{errorMessage}</div>} */}
        </div>
      </div>
    </div>
  );
};
